import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.find.js";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}; // import "@/polyfills";


import "jquery.cookie";
import { fhtCommonEnv } from "@/common/fhtGlobalEnv";
import jqueryDataUtil from "@/common/jqueryDataUtil";
import { assert } from "@/common/assert";
export function checkMobile() {
  // eslint-disable-next-line compat/compat
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(agent.substr(0, 4));
}
export function findDuplicates(arr) {
  var e_1, _a;

  assert(arr, "arr falsy");
  var dupes = new Set();
  var seen = new Set();

  try {
    for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
      var item = arr_1_1.value;

      if (seen.has(item)) {
        dupes.add(item);
      }

      seen.add(item);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (arr_1_1 && !arr_1_1.done && (_a = arr_1["return"])) _a.call(arr_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return dupes;
}
export function isFht1Authenticated() {
  return !!jqueryDataUtil.optionalBoolean($(document), "isFht1Authenticated");
}
/**
 * 清理缓存用的，原因见： http://192.168.1.228/T5482
 */

export function getAuthHash() {
  var authCookie = $.cookie("FhtAuthCookie");
  if (!authCookie) return fhtCommonEnv.AppVersion;
  var authCookieString = authCookie.substring(0, 16);
  assert(fhtCommonEnv.AppVersion, "fhtCommonEnv.AppVersion must be defined");
  return fhtCommonEnv.AppVersion + "_" + authCookieString;
}
$(document).ajaxError(function (_event, jqxhr, settings, _thrownError) {
  //see https://stackoverflow.com/questions/7436195/disabling-some-jquery-global-ajax-event-handlers-for-a-request
  if (settings.suppressErrors) {
    return;
  } //   const contentType = jqxhr.getResponseHeader("Content-Type");


  if (jqxhr.status === 401) {
    console.warn("HTTP 401 jqxhr", jqxhr);
    throw new Error("HTTP 401 (see console for detailed jqxhr), should we redirect to Login page??");
  }
}); //设置当前页面支持的最小IE版本，小于支持版本则跳转到相应页面

$(function () {
  var ieVersion = jqueryDataUtil.optionalNumber($(document.body), "ieSupport");

  if ($.browser && $.browser.msie && ieVersion && parseInt($.browser.version, 10) < ieVersion) {
    $(window).off("beforeunload"); // eslint-disable-next-line fht-eslint-rules/string-literal-validator

    window.location.href = "/Exception/BrowserUnsupported";
  }
}); //给一些元素添加hover显示还是隐藏的动效

$(".js-hover-contain").on("mouseenter", function () {
  $(this).find(".js-hover-contain__element").stop().fadeIn(300);
}).on("mouseleave", function () {
  $(this).find(".js-hover-contain__element").stop().fadeOut(300);
});